module.exports = __webpack_public_path__ + "static/img/3.c85b958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news28/3.png
// module id = BFTQ
// module chunks = 1